import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { O as OnElementMutation } from './p-7b2053f2.js';
const dividerCss = ".sc-owc-divider-h{display:grid;grid-template-columns:1fr auto 1fr;-ms-flex-align:center;align-items:center;width:100%;color:var(--one-color-background-contrast);white-space:nowrap;border-radius:var(--one-spacing-radius-4-xs);-webkit-box-sizing:border-box;box-sizing:border-box;font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-caption-font-size);line-height:var(--one-typography-desktop-caption-line-height);-webkit-font-kerning:var(--one-typography-desktop-caption-font-kerning);font-kerning:var(--one-typography-desktop-caption-font-kerning);font-weight:var(--one-text-font-weight-regular)}.sc-owc-divider-h .owc-divider__content-wrapper.sc-owc-divider{border-radius:inherit;color:inherit;z-index:2;cursor:inherit;margin:var(--one-spacing-padding-none) var(--one-spacing-padding-5-xs)}.sc-owc-divider-h::after{content:\"\";border-top:var(--one-spacing-outline-regular) solid currentColor}.sc-owc-divider-h::before{content:\"\";border-top:var(--one-spacing-outline-regular) solid currentColor}.owc-divider--direction-vertical.sc-owc-divider-h{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;align-self:stretch;grid-template-columns:auto;grid-template-rows:1fr auto 1fr;justify-items:center}.owc-divider--direction-vertical.sc-owc-divider-h::before{border-right:var(--one-spacing-outline-regular) solid currentColor;height:100%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.owc-divider--direction-vertical.sc-owc-divider-h::after{border-right:var(--one-spacing-outline-regular) solid currentColor;height:100%;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.owc-divider--direction-vertical.sc-owc-divider-h .owc-divider__content-wrapper.sc-owc-divider{margin:var(--one-spacing-padding-5-xs) var(--one-spacing-padding-none)}.owc-divider--empty.sc-owc-divider-h .owc-divider__content-wrapper.sc-owc-divider{margin:var(--one-spacing-padding-none)}.owc-divider--caption-position-start.sc-owc-divider-h{grid-template-columns:auto 1fr}.owc-divider--caption-position-start.sc-owc-divider-h::before{display:none}.owc-divider--caption-position-start.owc-divider--direction-vertical.sc-owc-divider-h{grid-template-columns:auto;grid-template-rows:auto 1fr}.owc-divider--caption-position-end.sc-owc-divider-h{grid-template-columns:1fr auto}.owc-divider--caption-position-end.sc-owc-divider-h::after{display:none}.owc-divider--caption-position-end.owc-divider--direction-vertical.sc-owc-divider-h{grid-template-columns:auto;grid-template-rows:1fr auto}.owc-divider--type-dashed.sc-owc-divider-h::before,.owc-divider--type-dashed.sc-owc-divider-h::after{border-top-style:dashed}.owc-divider--type-dashed.owc-divider--direction-vertical.sc-owc-divider-h::before,.owc-divider--type-dashed.owc-divider--direction-vertical.sc-owc-divider-h::after{border-right-style:dashed}.owc-divider--type-dotted.sc-owc-divider-h::before,.owc-divider--type-dotted.sc-owc-divider-h::after{border-top-style:dotted}.owc-divider--type-dotted.owc-divider--direction-vertical.sc-owc-divider-h::before,.owc-divider--type-dotted.owc-divider--direction-vertical.sc-owc-divider-h::after{border-right-style:dotted}@media (forced-colors: active){.sc-owc-divider-h::after{border-color:canvastext}.sc-owc-divider-h::before{border-color:canvastext}.sc-owc-divider-h .owc-divider__content-wrapper.sc-owc-divider{color:canvastext}}";
const OwcDividerStyle0 = dividerCss;
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const Divider = /*@__PURE__*/proxyCustomElement(class Divider extends H {
  constructor() {
    super();
    this.__registerHost();
    this.defaultSlotWrapper = useRef();
    this.component = new ComponentUtils(this);
    this.updateHasContent = () => {
      var _a, _b;
      return this.hasContent = ((_b = (_a = this.defaultSlotWrapper.current) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.length) > 0;
    };
    this.direction = 'horizontal';
    this.captionPosition = 'center';
    this.type = 'solid';
    this.hasContent = false;
  }
  onContentChange() {
    this.updateHasContent();
  }
  componentDidLoad() {
    this.updateHasContent();
  }
  render() {
    var _a;
    const hostClasses = this.component.getHostBemClasses({
      empty: !this.hasContent,
      [`direction-${this.direction || 'horizontal'}`]: true,
      [`caption-position-${this.captionPosition || 'center'}`]: true,
      [`type-${this.type || 'solid'}`]: true
    });
    const contentWrapperClasses = this.component.getChildBemClasses('content-wrapper', hostClasses);
    return h(Host, Object.assign({
      key: '451b75b2ede68fe677abb64b0ad13cfc2653cee4',
      class: hostClasses
    }, accessibility({
      role: 'separator',
      aria: {
        label: (_a = this.defaultSlotWrapper.current) === null || _a === void 0 ? void 0 : _a.textContent,
        orientation: this.direction === 'vertical' ? 'vertical' : 'horizontal'
      }
    })), h("div", {
      key: '1220ce9834238cc356250d19b587f585c5552df3',
      class: contentWrapperClasses,
      ref: this.defaultSlotWrapper
    }, h("slot", {
      key: 'c210998d37ccfd1bbfddbbcfc8ef193953467b74'
    })));
  }
  get hostElement() {
    return this;
  }
  static get style() {
    return OwcDividerStyle0;
  }
}, [6, "owc-divider", {
  "direction": [513],
  "captionPosition": [513, "caption-position"],
  "type": [513],
  "hasContent": [32]
}]);
__decorate([OnElementMutation({
  target: self => self.defaultSlotWrapper.current,
  childList: true,
  characterData: true,
  subtree: true
})], Divider.prototype, "onContentChange", null);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-divider"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-divider":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Divider);
        }
        break;
    }
  });
}
export { Divider as D, defineCustomElement as d };